import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { taxSavingSimulatorConstants } from '~/landing/core/simulator/tax-savings-simulator';

import { futureSavingsPlannerConstants } from './constants';
import { formSchema, type FormSchema } from './schema';

export const useFutureSavingsForm = () => {
  return useForm<FormSchema>({
    defaultValues: {
      futureSavingsPlanner: {
        initialDeposit: futureSavingsPlannerConstants.initialDeposit.default,
        monthlyPayment: futureSavingsPlannerConstants.monthlyPayment.default,
        birthDate: '2000-01-01',
        retirementAge: 64,
        riskProfile: 'DYNAMISM',
      },
      taxSavingsSimulator: {
        householdAnnualIncome:
          taxSavingSimulatorConstants.householdAnnualIncome.default,
        taxSharesHousehold:
          taxSavingSimulatorConstants.taxSharesHousehold.default,
      },
    },
    resolver: zodResolver(formSchema),
  });
};
